export namespace VeranstaltungConfigTypes {
    export const FUNKPROTOKOLL_MANDANT_OPTIONS = 'ver-funkprotokoll';
    export const VERANSTALTUNGEN_MANDANT_OPTIONS = 'ver-veranstaltungen';
    
}

